import { Component, ElementRef, Injectable, Renderer2 } from '@angular/core';
import { CustomLandingModule } from '../../custom-landing.module';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { I18nModule, TranslationService } from '@spartacus/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ToastrService } from 'ngx-toastr';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { NgbModal,NgbDatepickerI18n,NgbDatepickerConfig, NgbDateParserFormatter, NgbDateStruct, NgbDateAdapter, NgbModule, NgbDate, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl,FormArray, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'
import { AttatchmentModalComponent } from 'src/app/shared/components/attatchment-modal/attatchment-modal.component';
import { ShipmentVmsEblBlComponent } from '../shipment-vms-ebl-bl/shipment-vms-ebl-bl.component';
import moment from 'moment';
import { pairwise } from 'rxjs';
import { CustomProductsService } from '../../custom-products/custom-products.service';
import { AttachInvoiceComponent } from '../attach-invoice/attach-invoice.component';
import { PortInvoiceComponent } from '../port-invoice/port-invoice.component';
//import { ShipmentAssignmentComponent } from '../shipment-assignment/shipment-assignment.component';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
  }
}
// import { CustomUploadDocumentComponent } from 'src/app/shared/components/custom-upload-document/custom-upload-document.component';
// import { ShipmentVmsEditEblBlComponent } from '../shipment-vms-edit-ebl-bl/shipment-vms-edit-ebl-bl.component';

@Component({
    selector: 'app-batches-screening-details',
    imports: [CustomLandingModule, ReactiveFormsModule, CommonModule, RouterModule, I18nModule, SharedModule, NgbModule, NgbDatepickerModule],
    templateUrl: './batches-screening-details.component.html',
    styleUrl: './batches-screening-details.component.scss',
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    ]
})
export class BatchesScreeningDetailsComponent {
  id:any;
  passingArray:any;
  enableLoader: boolean = false;
  batchesScreendetails: any;
  checkCustomClearenceFlag:boolean ;
  selectYear: any;
  selectMonth: any;
  nextMonth: any;
  preMonth: any;
  SubstartDate: NgbDate = null;
  screeningConvertedDate: any;
  form:FormGroup;
  skillsForm: FormGroup;
  editScreeningFlag:boolean = false;
  editAllBtnFlag: boolean;
  screeningFormTemp: any[] = [];
  //reqErrorFlag:boolean=false;
  isAgentInvoiceActive: string = 'false';
  section: any;

  constructor(
    private toastrService: ToastrService,private translationService: TranslationService,
    private customProfile: CustomProfileService,
    private router:Router,private route:ActivatedRoute,
    public modalService: NgbModal,
    private config: NgbDatepickerConfig,
    private fb:FormBuilder, private el: ElementRef,
    private renderer: Renderer2,private customProductService:CustomProductsService
  ){ 
    //this.populateForm();

  }

  ngOnInit(){
     this.customProductService.returnAgentInvoiceActive().subscribe(res=>{
      this.isAgentInvoiceActive = res;
   })
    this.id = this.route.snapshot.paramMap.get('id');
    this.passingArray = {
      baseProductCode: this.route.snapshot.queryParams.baseProductCode,
      batchId: this.id,
    }
     if(this.router.url.includes('portside')){
      this.section = 'portside';
     } else if(this.router.url.includes('bondedwarehouse')){
      this.section = 'bondedwarehouse';
     }
    this.getBatchesScreeningdetails();
    this.enableLoader = true;
       this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
          this.enableLoader = true;
          if (current != null) {
            if (previous !== current) {
              this.getBatchesScreeningdetails();
            }
          }
        })
    

   
    // this.form = this.fb.group({
    //   nominationItemRecordPickUpEntryRequest: this.fb.array([]),    
    // });
  }
 
    
  
  getBatchesScreeningdetails(){
    this.enableLoader = true;
    let toastshown=false;

    this.customProfile.batchesScreeningDetails(this.passingArray).subscribe((data)=> {
      if(data){
        this.form = this.fb.group({    
          batchScreeningItemRequest: this.fb.array([]),
        });
        this.screeningFormTemp =[];
      this.batchesScreendetails = data;  
      this.checkCustomClearenceFlag = this.batchesScreendetails.screeningCompleted;  
      // addeing screening data(cards) to array
          if(this.batchesScreendetails?.screeningEntries.length>0){
            this.batchesScreendetails?.screeningEntries.forEach((item:any)=>{
              this.addScreening(item)
              this.editScreeningFlag = false;
            })
          }else{
            this.addScreening('');
          }
          this.enableLoader = false;
        }
       
        else{
       //   this.toastrService.show('No data returned from Commerce, please contact support team')
       this.translationService.translate('shipment.emptyerrormessage').subscribe(res=>{   
        if(!toastshown){
          this.toastrService.show(res);
          toastshown=true;
        }
      })
        }
    }, err => {
      //this.toastrService.show('Delivery tracking details having some error')
      this.translationService.translate('batches.deliveryError').subscribe(res=>{   
        if(!toastshown){
          this.toastrService.show(res);
          toastshown=true;
        }
      })
      this.enableLoader = false;
    })
  }
    checkBatchCompleted(flag){
      if(flag == 'no'){
        this.checkCustomClearenceFlag = false;
      }else{
        this.checkCustomClearenceFlag = true;    
            const modalRef = this.modalService.open(ShipmentVmsEblBlComponent, { centered: true, size: 'lg' });
            modalRef.componentInstance.shipData = this.batchesScreendetails;
            modalRef.componentInstance.modalToOpen = 'screeningCompleted';
            modalRef.componentInstance.flag = this.checkCustomClearenceFlag;   
            modalRef.result.then(res=>{
              if(res=='success'){
                this.getBatchesScreeningdetails();
              }else if(res=='close'){
                const previouslyActive = this.el.nativeElement.querySelector('.active');
                  if (previouslyActive) {
                    this.renderer.removeClass(previouslyActive, 'active');
                  }
                this.checkCustomClearenceFlag = false;    
              }
            })
      }
    }

    toggle(data: any) {
      data.toggle();
      let element3 = document.getElementsByClassName("btn btn-link ngb-dp-arrow-btn");
      for (let i = 0; i < element3.length; i++) {
        let value = element3[i].getAttribute("title");
        element3[i].setAttribute("title", this.setTitle(value));
      }
  
      let element4 = document.getElementsByTagName("ngb-datepicker-navigation-select")[0].children;
      for (let i = 0; i < element4.length; i++) {
        let value = element4[i].getAttribute("title");
        element4[i].setAttribute("title", this.setTitle(value))
      }
    }
    setTitle(value) {
      switch (value) {
        case "Select year": return this.selectYear;
        case "Select month": return this.selectMonth;
        case "Next month": return this.nextMonth;
        case "Previous month": return this.preMonth;
        default: return;
      }
    }

     formatDate(dateString: string): string {
      const a = dateString.split('-');
      if(a.length>1){
        let formatenddate = dateString.replace(/\-/g,'/');
        return formatenddate
      }else{
        return dateString;
      }
     
    }

    checkPad(d) {
      return (d < 10) ? '0' + d.toString() : d?.toString();
    }

    dateSelected(selectedDate,index){
      this.SubstartDate = selectedDate;
      if (this.SubstartDate != null) {
        let convertedDate =  this.checkPad(this.SubstartDate.day)+'/' + this.checkPad(this.SubstartDate.month) + '/'+ this.SubstartDate.year ;      
        this.batchScreeningItemRequest.at(index).setValue({screeningEntryDate:convertedDate})
      }
    }

    get batchScreeningItemRequest() {
      return this.form.controls["batchScreeningItemRequest"] as FormArray;
    }
   
    addScreening(data:any) {
      let tempObj={} ;
        if( data != ""){
        let screeningForm = this.fb.group({
          screeningEntryNumber:[data.screeningEntryNumber?data.screeningEntryNumber:''],
           entryDate: [{value:data.entryDate?data.entryDate:'NA',disabled:true}],  
           screenedNblluQty:[{value:data.screenedNblluQty?data.screenedNblluQty:'', disabled:true}],
           actualNbslQty:[{value:data.actualNbslQty?data.actualNbslQty:'',disabled:true}],
           actualNbsfQty:[{value:data.actualNbsfQty?data.actualNbsfQty:'',disabled:true}],
           nbslLoc:[{value:data.nbslLoc?data.nbslLoc:'',disabled:true}],
           nbsfLoc:[{value:data.nbsfLoc?data.nbsfLoc:'',disabled:true}],
           screeningRemarks:[{value:data.screeningRemarks?data.screeningRemarks:'',disabled:true}],
           screeningEntryDate:[{value:data.screeningEntryDate?data.screeningEntryDate:'NA',disabled:true}, Validators.required],
          lastUpdatedOn:[{value:data.lastUpdatedOn?data.lastUpdatedOn:'NA',disabled:true}],
          lastUpdatedBy:[{value:data.lastUpdatedBy?data.lastUpdatedBy:'',disabled:true}],
          plannedNblluQty:[{value:data.plannedNblluQty?data.plannedNblluQty :'',disabled:true}],
          nbslNbsfRatio:[{value:data.nbslNbsfRatio?data.nbslNbsfRatio:'',disabled:true}],
       
        });
        tempObj = {screeningEntryNumber :data.screeningEntryNumber,editScreeningThisFlag :false,reqErrorFlag:false }
        this.screeningFormTemp.unshift(tempObj);
        this.batchScreeningItemRequest.insert(this.screeningFormTemp.length || 0,screeningForm);
        this.editScreeningFlag=false;
      }else {
        //this.editScreeningFlag = true;
        let screeningForm = this.fb.group({
          screeningEntryNumber:[''],
          screeningEntryDate: [{value:'',disabled:false}, Validators.required],
          screenedNblluQty:[{value:'', disabled:true}],
          actualNbslQty:[{value:'',disabled:false}],
          actualNbsfQty:[{value:'',disabled:false}],
          nbslLoc:[{value:'',disabled:false}],
          nbsfLoc:[{value:'',disabled:false}],
          screeningRemarks:[{value:'',disabled:false}],
          entryDate:[{value:'',disabled:true}],
          lastUpdatedOn:[{value:'',disabled:true}],
          lastUpdatedBy:[{value:'',disabled:true}],
          plannedNblluQty:[{value:'',disabled:false}],
          nbslNbsfRatio:[{value:'',disabled:true}],
        
        });
        //this screeningFormTemparray creating to maintain flags which needs to be update externally based on condition
        tempObj = {screeningEntryNumber :data.screeningEntryNumber,editScreeningThisFlag :true,reqErrorFlag:false }
        this.screeningFormTemp.unshift(tempObj);
        this.batchScreeningItemRequest.insert(0,screeningForm);
        this.editScreeningFlag=true;
      }
    }

    editAll(form){
       this.editAllBtnFlag = true;
       this.editScreeningFlag = true;
      let rawValue = form.getRawValue();
      let formattedvalues = rawValue.batchScreeningItemRequest;
     for(let i=0; i<formattedvalues.length; i++){
      // if(form.getRawValue().screeningEntryNumber==this.screeningFormTemp.value.screeningEntryNumber){
      //   this.screeningFormTemp.editScreeningThisFlag =true; 
      // }
        this.screeningFormTemp[i].editScreeningThisFlag = true;
        this.batchScreeningItemRequest.at(i).get('screeningEntryDate').enable();
        if(this.batchScreeningItemRequest.at(i).get('screeningEntryDate').value){
          let formatdate = this.batchScreeningItemRequest.at(i).get('screeningEntryDate').value.replace(/\//g,'-');
          this.batchScreeningItemRequest.at(i).get('screeningEntryDate').setValue(formatdate);
        }
          this.batchScreeningItemRequest.at(i).get('plannedNblluQty').enable();
          this.batchScreeningItemRequest.at(i).get('actualNbslQty').enable();
          this.batchScreeningItemRequest.at(i).get('actualNbsfQty').enable();
          this.batchScreeningItemRequest.at(i).get('nbslLoc').enable();
          this.batchScreeningItemRequest.at(i).get('nbsfLoc').enable();
          this.batchScreeningItemRequest.at(i).get('screeningRemarks').enable();
     }  
    }

    saveAll(form){
      let formattedvalues = JSON.parse(JSON.stringify(form.getRawValue().batchScreeningItemRequest));
      if(form.valid){
        this.editScreeningFlag = false;
        let screeningEntries=[];
        let dataObj;      
        this.enableLoader = true;
        let toastshown=false;
        
        if (form.value.batchScreeningItemRequest.length > 0) {
          //this.emptysaveErr = false;
          formattedvalues.forEach(e => {
            e.screeningEntryDate = this.formatDate(e.screeningEntryDate);
            dataObj={
              "screeningEntryNumber": e.screeningEntryNumber?e.screeningEntryNumber:'',
              "screeningEntryDate":e.screeningEntryDate,
              "plannedNblluQty": e.plannedNblluQty,
              "actualNbslQty": e.actualNbslQty,
              "actualNbsfQty": e.actualNbsfQty,
              "nbslLoc": e.nbslLoc,
              "nbsfLoc": e.nbsfLoc,
              "screeningRemarks": e.screeningRemarks,
            }   
            screeningEntries.push(dataObj);      
          })        
        }
        const SaveObject = {
          "screeningEntries":screeningEntries
        }
        this.customProfile.updateScreeningEntry(SaveObject,this.passingArray).subscribe(res => {
          this.enableLoader = false;
          if (res) {
             this.translationService.translate('batches.saveAllScreening').subscribe(res=>{
              if(!toastshown){
                this.toastrService.show(res);
                toastshown = true;
              }
            })        
            this.enableLoader = false;            
            this.getBatchesScreeningdetails();
            this.editAllBtnFlag = false;

            // formattedvalues.forEach(e => {
            //   this.screeningFormTemp[e].editScreeningThisFlag = false;
            //   });
          }   
        }, err => {
          this.translationService.translate('batches.singleScreeningNotSave').subscribe(res=>{
            if(!toastshown){
              this.toastrService.show(res);
              toastshown = true;
            }
          }); 
           this.enableLoader = false;
        })
      }else{
        if (form.value.batchScreeningItemRequest.length > 0) {
          //this.emptysaveErr = false;
          for(let i=0; i<formattedvalues.length; i++){
            formattedvalues[i].screeningEntryDate?this.screeningFormTemp[i].reqErrorFlag = false:this.screeningFormTemp[i].reqErrorFlag = true;
          }
            
          // formattedvalues.forEach(e => {
          //   e.screeningEntryDate?this.screeningFormTemp[e].reqErrorFlag = false:this.screeningFormTemp[e].reqErrorFlag = true;
          // });
        }      
      }
    }

    editScreeningRecord(item,index){
      this.screeningFormTemp[index].editScreeningThisFlag = true;
      
      this.batchScreeningItemRequest.at(index).get('screeningEntryDate').enable();
      if(this.batchScreeningItemRequest.at(index).get('screeningEntryDate').value){
        let formatdate = this.batchScreeningItemRequest.at(index).get('screeningEntryDate').value.replace(/\//g,'-');
        this.batchScreeningItemRequest.at(index).get('screeningEntryDate').setValue(formatdate);
      }
      this.batchScreeningItemRequest.at(index).get('plannedNblluQty').enable();
      this.batchScreeningItemRequest.at(index).get('actualNbslQty').enable();
      this.batchScreeningItemRequest.at(index).get('actualNbsfQty').enable();
      this.batchScreeningItemRequest.at(index).get('nbslLoc').enable();
      this.batchScreeningItemRequest.at(index).get('nbsfLoc').enable();
      this.batchScreeningItemRequest.at(index).get('screeningRemarks').enable();

    }

    saveScreeningRecord(item,index){
      if(item.valid){
        this.screeningFormTemp[index].reqErrorFlag = false;
        const formData = this.batchScreeningItemRequest.at(index).value;
        //const screeningDate = this.checkPad(formData.screeningEntryDate.day)+ '/'+this.checkPad(formData.screeningEntryDate.month) +'/'+formData.screeningEntryDate.year ;
        const screeningDate = this.formatDate(formData.screeningEntryDate);
        let toastshown=false;
  
        const SaveObject = 
          {
            screeningEntries:[{
              "screeningEntryNumber": formData.screeningEntryNumber?formData.screeningEntryNumber:'',
              "screeningEntryDate":screeningDate,
              "plannedNblluQty": formData.plannedNblluQty,
              "actualNbslQty": formData.actualNbslQty,
              "actualNbsfQty": formData.actualNbsfQty,
              "nbslLoc": formData.nbslLoc,
              "nbsfLoc": formData.nbsfLoc,
              "screeningRemarks": formData.screeningRemarks,
            }]          
          }
          this.enableLoader = true;
         // let toastshown = false;
  
          this.customProfile.updateScreeningEntry(SaveObject,this.passingArray).subscribe(res => {
            
            if (res != '') {
              this.translationService.translate('batches.singleScreeningSave').subscribe(res=>{
                if(!toastshown){
                  this.toastrService.show(res);
                  toastshown = true;
                }
              })
              //this.toastrService.show('Screening Entry saved successfully.')         
              this.enableLoader = false;   
              this.batchScreeningItemRequest.at(index).patchValue({
                screeningEntryNumber:res.screeningEntryNumber,
                entryDate: res.entryDate,  
                screenedNblluQty:res.screenedNblluQty,
                actualNbslQty:res.actualNbslQty,
                actualNbsfQty:res.actualNbsfQty,
                nbslLoc:res.nbslLoc,
                nbsfLoc:res.nbsfLoc,
                screeningRemarks:res.screeningRemarks,
                screeningEntryDate:res.screeningEntryDate,
                lastUpdatedOn:res.lastUpdatedOn,
                lastUpdatedBy:res.lastUpdatedBy,
                plannedNblluQty:res.plannedNblluQty,
                nbslNbsfRatio:res.nbslNbsfRatio        
              }) 
              this.batchScreeningItemRequest.at(index).get('screeningEntryDate').disable();
              this.batchScreeningItemRequest.at(index).get('plannedNblluQty').disable();
              this.batchScreeningItemRequest.at(index).get('actualNbslQty').disable();
              this.batchScreeningItemRequest.at(index).get('actualNbsfQty').disable();
              this.batchScreeningItemRequest.at(index).get('nbslLoc').disable();
              this.batchScreeningItemRequest.at(index).get('nbsfLoc').disable();
              this.batchScreeningItemRequest.at(index).get('screeningRemarks').disable();
              this.screeningFormTemp[index].editScreeningThisFlag = false;
              this.getBatchesScreeningdetails();
            }else{
              this.translationService.translate('batches.emptyRecord').subscribe(res=>{
                if(!toastshown){
                  this.toastrService.show(res);
                  toastshown = true;
                }
              }) 
            }
          }, err => {
            this.translationService.translate('batches.singleScreeningNotSave').subscribe(res=>{
              if(!toastshown){
                this.toastrService.show(res);
                toastshown = true;
              }
            })       
            this.enableLoader = false;
          })
      }else{
        this.screeningFormTemp[index].reqErrorFlag = true;
        //this.reqErrorFlag = true;
      }
    }
   
   
    backToBatchesScreeningList() {
      this.router.navigate(['/dvl-screening-list/dvl-screening-list/'+ this.section],{queryParams:{from:'details'}});
    }
    goToAttachment() {
      const ModalRef = this.modalService.open(AttatchmentModalComponent, { centered: true, size: 'lg' });
      ModalRef.componentInstance.batchScreenData = this.batchesScreendetails;
      ModalRef.componentInstance.fromComponent = 'batchesScreendetails';
      ModalRef.result.then(res=>{
        if(res=='success'){
          this.getBatchesScreeningdetails();
        }
      })
      
      }

      donwloadReport(reportType) {
        let toastshown=false;
        if (reportType === 'screening_report'|| reportType === 'bonded_warehouse_screening_report') {
          this.enableLoader = true;
          const baseProductCode = this.passingArray.baseProductCode
          const batchId =  this.passingArray.batchId
          this.customProfile.exportReport(reportType,baseProductCode+'_'+batchId).subscribe(res => {
            if (res.code) {
              const ref = document.createElement("a");
              ref.href = `data:application/xlsx;base64,${res.code}`
              if(reportType === 'screening_report'){
                ref.download = `Screening report.xlsx`
              }else if(reportType == 'bonded_warehouse_screening_report'){
                ref.download = `BW-Screening report.xlsx`
              }
              ref.click()
              this.enableLoader = false;
              this.translationService.translate('shipment.downloaddoc').subscribe(res=>{
                if(!toastshown){
                  this.toastrService.show(res);
                  toastshown = true;
                }
              })
            }
            else {
              this.enableLoader = false;
              this.toastrService.show(res.status);
            }
    
          }, err => {
            this.enableLoader = false;
            this.translationService.translate('shipment.downloadunsuccess').subscribe(res=>{   
              if(!toastshown){
                this.toastrService.show(res);
                toastshown = true;
              }
            })
            // this.toastrService.show('Download unsuccessful, please contact support team.');
          })
        }
      }
       openInvoices(data: any){
            const modalref = this.modalService.open(AttachInvoiceComponent, {
              centered: true,
              size: 'lg',
              backdrop: 'static',
              keyboard: false,
            });
            modalref.componentInstance.display='invoices';
            modalref.componentInstance.batchData = data;
              modalref.componentInstance.useCaseType =  'SCREENINGINVOICE_UC3';
          }
       openPortInvoices(data: any){
            const modalref = this.modalService.open(PortInvoiceComponent, {
              centered: true,
              size: 'lg',
              backdrop: 'static',
              keyboard: false,
            });
            modalref.componentInstance.display='portInvoices';
            modalref.componentInstance.batchData = data;
              modalref.componentInstance.useCaseType =  'SCREENINGINVOICE_UC3';
          }
}
